import { render, staticRenderFns } from "./AffiliateAccountsCard.vue?vue&type=template&id=1a0de328&"
import script from "./AffiliateAccountsCard.vue?vue&type=script&lang=js&"
export * from "./AffiliateAccountsCard.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports